import OpenItem from './OpenItem.jsx';
import { INTEREST_STATUS_WORDS, ON_BINDER_WORDS, CERT_WORDS, NOT_RECORDED, word } from './words.js';

// THE INTERESTS (lienholders, additional insureds) on the account, active
// and ended, each with its registrations, place, status word, whether it is
// on the binder (a word for true, false AND null) and its certificate state.
// An AIRgus item naming an interest sits under its row.

export default function InterestsSection({ interests = [], byRef, remedyHref }) {
  const itemsFor = (i) => [...byRef.entries()].filter(([k]) => k.startsWith(`interest:${i.id}:`)).flatMap(([, v]) => v);
  return (
    <section className="rounded-card border border-border bg-surface" data-interests>
      <header className="flex items-baseline justify-between border-b border-border px-4 py-2.5">
        <h2 className="text-xs font-semibold uppercase tracking-[0.14em] text-text-muted">Interests</h2>
        <span className="font-mono text-[10px] text-text-dim">{interests.length}</span>
      </header>
      <div className="px-4">
        {interests.length === 0 ? <p className="py-3 text-xs italic text-text-dim">No interests on this account.</p> : null}
        {interests.map((i) => (
          <div key={i.id} className="border-b border-border py-2 last:border-b-0" data-interest={i.id}>
            <div className="flex flex-wrap items-baseline gap-x-3 gap-y-0.5">
              <span className={`text-sm font-medium ${i.status === 'ended' ? 'text-text-dim line-through' : 'text-text'}`}>{i.name}</span>
              <span className="text-xs text-text-muted">{i.type ? String(i.type).replace(/_/g, ' ') : NOT_RECORDED}</span>
              <span className="font-mono text-xs text-text-muted">{(i.registrations || []).join(', ') || NOT_RECORDED}</span>
              <span className="text-xs text-text-dim">{[i.city, i.state].filter(Boolean).join(', ') || NOT_RECORDED}</span>
              <span className="ml-auto flex gap-3 text-xs text-text-dim">
                <span data-interest-status>{word(INTEREST_STATUS_WORDS, i.status)}</span>
                <span data-on-binder>{ON_BINDER_WORDS[String(i.on_binder)] || NOT_RECORDED}</span>
                <span>{word(CERT_WORDS, i.certificate?.status)}</span>
              </span>
            </div>
            {itemsFor(i).map((it, k) => <OpenItem key={it.code + k} item={it} compact href={remedyHref?.(it)} />)}
          </div>
        ))}
      </div>
    </section>
  );
}
